<template>
  <div id="app">
    <navbar title="SysJudge" />
    <sidebar></sidebar>
    <router-view />
    <judge-footer></judge-footer>
  </div>
</template>

<style>
#app {
  font-family: Verdana, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.modal {
  font-family: Verdana, Arial, sans-serif;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
export default {
  metaInfo() {
    return {
      title: "SysJudge",
      meta: [
        {
          name: "description",
          content: "SysJudge - a Online Judge System for System Administrator.",
        },
        { property: "og:title", content: "SysJudge - Online Judge System " },
        { property: "og:site_name", content: "SysJudge" },
      ],
    };
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>